import { render, staticRenderFns } from "./ProjectNew.vue?vue&type=template&id=27cd39ec&scoped=true&"
import script from "./ProjectNew.vue?vue&type=script&lang=js&"
export * from "./ProjectNew.vue?vue&type=script&lang=js&"
import style0 from "./ProjectNew.vue?vue&type=style&index=0&id=27cd39ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd39ec",
  null
  
)

export default component.exports